import PropTypes from "prop-types";

// Custom components
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";

// MUI
import { Stack } from "@mui/material";

const getCommissionsInputs = (crossStore = false, readOnly = false) => {
	if (!crossStore) {
		return [
			{
				type: "Percent",
				min: 0,
				max: 100,
				decimalsEditable: true,
				decimals: 2,
				readOnly,
			},
			{
				type: "Dollar",
				min: 0,
				max: 999999.99,
				decimalsEditable: true,
				decimals: 2,
				readOnly,
			},
			{
				type: "Dollar per Unit",
				min: 0,
				max: 999999.99,
				decimalsEditable: true,
				decimals: 2,
				readOnly,
			},
		];
	}

	return [
		{
			type: "Percent",
			min: 0,
			max: 100,
			decimalsEditable: true,
			decimals: 2,
			readOnly,
		},
		{
			type: "Dollar per Unit",
			min: 0,
			max: 999999.99,
			decimalsEditable: true,
			decimals: 2,
			readOnly,
		},
	];
};

export default function MatrixRow(props) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		grossErrorOnLastRow = false,
		spacing = 0.8,
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		crossStore = false,
		finance = false,
		readOnly = false,
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	const doubleInputDefinition = !finance
		? {
				type: "Dollar",
				min: -99999.99,
				max: 99999.99,
				decimalsEditable: true,
				decimals: 2,
				delta: 0.01,
		  }
		: {
				type: "Dollar",
				min: 0,
				max: 99999.99,
				decimalsEditable: true,
				decimals: 2,
				delta: 0.01,
		  };

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: [{ ...doubleInputDefinition, dashed: fromDisabled }],
							sx: { width: "106px" },
							defaultType: item?.from?.input || "Dollar",
							value: item?.from?.value || 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
						}}
						secondInput={{
							readOnly,
							data: [{ ...doubleInputDefinition, dashed: toDisabled }],
							sx: { width: "106px" },
							defaultType: item?.to?.type || "Dollar",
							value: item?.to?.value || 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, 0, "row", "to", value);
							},
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.commissions?.map((element, key) => {
						const lastItem = key === item?.commissions?.length - 1;
						const grossError = lastItem && grossErrorOnLastRow;
						return (
							<Stack key={`${index}_${key}`} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={getCommissionsInputs(crossStore, readOnly)}
									value={element?.commission?.value || 0}
									defaultType={element?.commission?.input || "Percent"}
									error={Boolean(columnsErrors?.[index]?.[key]?.["commission"]) || grossError}
									disabled={readOnly}
									readOnly={readOnly}
									onChangeType={(_, input) => {
										onChangeType?.(index, key, "row", "commission", input);
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.(index, key, "row", "commission", value);
									}}
									sx={{
										width: "95px",
									}}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
MatrixRow.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	spaces: PropTypes.object,
	rowsErrors: PropTypes.array,
	columnsErrors: PropTypes.array,
	grossErrorOnLastRow: PropTypes.bool,
	spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	mainContentProps: PropTypes.object,
	sxMainContent: PropTypes.object,
	cellsProps: PropTypes.object,
	sxCells: PropTypes.object,
	crossStore: PropTypes.bool,
	finance: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	onChangeType: PropTypes.func,
};
